<template>
  <div v-if="pageLoading" class="text-center">
    <looping-rhombuses-spinner
      :animation-duration="2500"
      :rhombus-size="15"
      color="#6200ea"
      class="mx-auto my-10"
    />
  </div>
  <div v-else class="profile">
    <div class="d-flex flex-wrap">
      <v-col xl="3" lg="3" md="12" sm="12" xs="12" cols="12">
        <v-card class="common-card rounded-lg">
          <div class="d-flex flex-wrap align-center">
            <div class="img-user">
              <img
                :src="userData.avatarId ? userData.avatarUrl : 'Avatar.png'"
                alt=""
              />
            </div>

            <div class="info-user">
              <p>
                {{ userData.name }}
              </p>
              <p>
                {{ userData.mobile }}
              </p>
            </div>
          </div>
          <hr />
          <v-tabs vertical v-model="tabs" color="#6200ea">
            <v-tabs-slider color="shopPrimary--text"></v-tabs-slider>
            <v-tab class="d-flex justify-start">
              <v-icon class="me-4">$BigUser</v-icon>
              <span class="fs-medium font-weight-bold">اطلاعات پروفایل</span>
            </v-tab>
            <v-tab class="d-flex justify-start">
              <v-icon class="me-4">$SmallShopCart</v-icon>
              <span class="fs-medium font-weight-bold">لیست خریدها</span>
            </v-tab>
            <v-tab class="d-flex justify-start">
              <v-icon class="me-4">$Location</v-icon>
              <span class="fs-medium font-weight-bold">لیست آدرس‌ها </span>
            </v-tab>
            <v-tab class="d-flex justify-start">
              <v-icon class="me-4">$BlackHeart</v-icon>
              <span class="fs-medium font-weight-bold"
                >لیست علاقه‌مندی‌ها
              </span>
            </v-tab>
            <v-tab class="d-flex justify-start">
              <v-icon class="me-4">mdi-message-outline</v-icon>
              <span class="fs-medium font-weight-bold">
                پیام‌ها و تخفیفات
              </span>
            </v-tab>
          </v-tabs>
        </v-card>
      </v-col>
      <v-col xl="9" lg="9" md="12" sm="12" xs="12" cols="12">
        <v-tabs-items v-model="tabs" class="rounded-lg" touchless>
          <!--Profile Information-->
          <v-tab-item>
            <v-card class="common-card">
              <v-card-title class="white black--text p-0">
                <div class="d-flex align-center">
                  <v-icon class="me-3 black--text fs-small">$BigUser</v-icon>
                  <span class="fs-medium2"> اطلاعات پروفایل </span>
                </div>
              </v-card-title>
              <v-card-text class="mainFont--text pt-8">
                <v-row>
                  <v-col cols="12" md="4" class="py-0">
                    <div class="img-user">
                      <img
                        :src="
                          userData.avatarId ? userData.avatarUrl : 'Avatar.png'
                        "
                        alt=""
                        style="border-radius: 50%"
                      />
                    </div>
                  </v-col>
                  <v-col cols="12" md="4" class="d-none d-md-flex"></v-col>
                  <v-col cols="12" md="4">
                    <div>
                      <b>نام و نام خانوادگی : </b>
                      <span>{{ userData.name }}</span>
                    </div>
                  </v-col>
                </v-row>
                <v-row class="mb-5">
                  <v-col cols="12" md="8">
                    <div>
                      <b>شماره موبایل : </b>
                      <span>{{ userData.mobile }}</span>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <b>ایمیل : </b>
                    <span>{{ userData.email }}</span>
                  </v-col>
                </v-row>
                <v-row class="w-100 d-flex justify-content-end">
                  <div
                    class="pointer d-flex align-center"
                    @click="openEditPersonalInfo()"
                  >
                    <v-icon
                      small
                      class="fs-small me-3 shopPrimary--text orange-icon"
                      >$Edit</v-icon
                    >
                    <span class="shopPrimary--text">ویرایش</span>
                  </div>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <!--Purchased list-->
          <v-tab-item>
            <v-card class="common-card">
              <v-card-title class="white black--text p-0 mb-6">
                <div class="d-flex align-center">
                  <v-icon class="me-3 black--text">$SmallShopCart</v-icon>
                  <span class="fs-medium2">لیست خریدها</span>
                </div>
              </v-card-title>

              <div
                v-for="(item, index) in shopInvoices.slice(
                  (currentPage - 1) * perPage,
                  currentPage * perPage
                )"
                :key="index"
              >
                <v-card outlined light class="mb-4 card-profile">
                  <div class="line-items-profile mt-4">
                    <v-col xl="4" lg="4" md="4" sm="6" xs="6" class="pt-0">
                      <div class="d-flex align-center">
                        <span
                          class="fs-medium font-weight-bold mainFont--text ml-1"
                        >
                          کد خرید:
                        </span>
                        <span class="fs-medium font-weight-bold primary--text">
                          {{ item.invoiceCode }}
                        </span>
                      </div>
                    </v-col>

                    <v-col xl="4" lg="4" md="4" sm="6" xs="6" class="pt-0">
                      <div
                        :class="[
                          'd-flex align-center',
                          $vuetify.breakpoint.mdAndUp
                            ? 'justify-content-center'
                            : '',
                        ]"
                      >
                        <span
                          class="fs-medium font-weight-bold mainFont--text ml-1"
                        >
                          تاریخ خرید:</span
                        >
                        <span
                          class="fs-medium font-weight-bold primary--text"
                          >{{ item.date }}</span
                        >
                      </div>
                    </v-col>

                    <v-col xl="4" lg="4" md="4" sm="6" xs="6" class="pt-0">
                      <div
                        :class="[
                          'd-flex align-center ',
                          $vuetify.breakpoint.mdAndUp
                            ? 'justify-content-end'
                            : '',
                        ]"
                      >
                        <span
                          :class="[
                            'fs-medium font-weight-bold ml-1',
                            item.status === 'ثبت شده'
                              ? 'activestatus'
                              : item.status === 'لغو شده'
                              ? 'deactivestatus'
                              : 'pendingClass',
                          ]"
                          >{{ item.status }}</span
                        >
                      </div>
                    </v-col>

                    <v-col xl="4" lg="4" md="4" sm="6" xs="6" class="pt-0">
                      <div class="d-flex align-center">
                        <span
                          class="fs-medium mainFont--text font-weight-bold ml-1"
                          >مجموع هزینه کالاها:</span
                        >
                        <span class="fs-medium font-weight-bold primary--text"
                          >{{
                            Number(item.totalCost).toLocaleString()
                          }}
                          تومان</span
                        >
                      </div>
                    </v-col>

                    <v-col xl="4" lg="4" md="4" sm="6" xs="6" class="pt-0">
                      <div
                        :class="[
                          'd-flex align-center ',
                          $vuetify.breakpoint.mdAndUp
                            ? 'justify-content-center'
                            : '',
                        ]"
                      >
                        <span
                          class="fs-medium mainFont--text font-weight-bold ml-1"
                          >هزینه حمل و نقل:</span
                        >
                        <span class="fs-medium font-weight-bold primary--text"
                          >{{
                            Number(item.shippingCost).toLocaleString()
                          }}
                          تومان</span
                        >
                      </div>
                    </v-col>

                    <v-col xl="4" lg="4" md="4" sm="6" xs="6" class="pt-0">
                      <div
                        v-if="item.status === 'ثبت شده'"
                        :class="[
                          'd-flex align-center ',
                          $vuetify.breakpoint.mdAndUp
                            ? 'justify-content-end'
                            : '',
                        ]"
                      >
                        <span
                          class="fs-medium mainFont--text font-weight-bold ml-1"
                          >هزینه پرداخت شده:</span
                        >
                        <span class="fs-medium font-weight-bold primary--text"
                          >{{
                            Number(item.totalPayablePrice).toLocaleString()
                          }}
                          تومان</span
                        >
                      </div>
                    </v-col>
                  </div>

                  <v-col xl="12" lg="12" md="12" sm="12" xs="6" class="py-0">
                    <v-divider class="#4a5f73 m-0"></v-divider>
                  </v-col>

                  <div class="pa-4">
                    <v-row class="d-flex flex-warp">
                      <v-col
                        xl="1"
                        lg="2"
                        md="2"
                        sm="3"
                        xs="6"
                        cols="6"
                        v-for="(image, index) in item.images"
                        :key="index"
                      >
                        <div class="image-list-buy">
                          <img :src="image.pictureUrl" alt="" />
                          <h6 class="font-weight-bold">
                            تعداد: {{ item.itemsDetail[index].amount }}
                          </h6>
                        </div>
                      </v-col>
                    </v-row>
                    <!-- <v-col xl="3" lg="3" md="3" sm="12" xs="12" align-self="end">
                          <Button
                            btnFilter
                            class="seemore-ordersUser end-item"
                            @click="goToDetails(index)"
                          >
                            <svg-icon type="mdi" :path="pathClipboar"></svg-icon>
                            <span>مشاهده جزییات و فاکتور </span>
                            <svg-icon
                              type="mdi"
                              :path="patheCherv"
                              class="icon-seemore"
                            ></svg-icon>
                          </Button>
                        </v-col> -->
                  </div>
                </v-card>
              </div>
              <v-col
                xl="12"
                lg="12"
                md="12"
                sm="12"
                xs="12"
                cols="12"
                v-if="shopInvoices.length"
              >
                <div class="page_number_order">
                  <v-pagination
                    v-model="currentPage"
                    :length="Math.ceil(shopInvoicesLength / perPage)"
                    :total-visible="5"
                    next-icon="mdi-menu-right"
                    prev-icon="mdi-menu-left"
                  ></v-pagination>
                </div>
              </v-col>
              <!--              <v-card-text>
                                <v-data-table
                                  :headers="purchaseFields"
                                  :items="computedItems"
                                  :page.sync="currentPagePurch"
                                  :items-per-page="perPagePurch"
                                  :expanded.sync="expanded"
                                  no-results-text="موردی برای نمایش وجود ندارد!"
                                  hide-default-footer
                                  item-key="id"
                                  loading-text="در حال بارگذاری اطلاعات..."
                                >
                                  <template slot="no-data">
                                    <div class="font-weight-bold">
                                      موردی برای نمایش وجود ندارد!
                                    </div>
                                  </template>

                                  &lt;!&ndash;index&ndash;&gt;
                                  <template v-slot:[`item.index`]="{ index }">
                                    {{ index + perPage * (currentPage - 1) + 1 }}
                                  </template>
                                  &lt;!&ndash;Total cost&ndash;&gt;
                                  <template v-slot:[`item.totalCost`]="{ item }">
                                    {{ item.totalCost ? item.totalCost.toLocaleString() : 0 }}
                                  </template>
                                  &lt;!&ndash;Total Payable price&ndash;&gt;
                                  <template v-slot:[`item.totalPayablePrice`]="{ item }">
                                    {{
                                      item.totalPayablePrice
                                        ? item.totalPayablePrice.toLocaleString()
                                        : 0
                                    }}
                                  </template>
                                  &lt;!&ndash; actions &ndash;&gt;
                                  <template v-slot:[`item.operation`]="{ item }">
                                    <v-btn
                                      width="150"
                                      class="shopPrimary white&#45;&#45;text"
                                      @click="goToDetails(item)"
                                    >
                                      <v-icon class="light-icon me-1">$EyeOn</v-icon>جزئیات خرید
                                    </v-btn>
                                  </template>
                                </v-data-table>

                                <div class="mt-6">
                                  <v-pagination
                                    v-model="currentPagePurch"
                                    :length="Math.ceil(computedItems.length / perPagePurch)"
                                    :total-visible="5"
                                    circle
                                    color="shopPrimary"
                                  ></v-pagination>
                                </div>
                              </v-card-text>-->
            </v-card>
          </v-tab-item>

          <!-- address List -->
          <v-tab-item>
            <v-card class="common-card">
              <v-card-title class="white black--text p-0 mb-6">
                <div class="d-flex align-center">
                  <v-icon class="me-3 black--text">$Location</v-icon>
                  <span class="fs-medium2">لیست آدرس ها</span>
                </div>
              </v-card-title>
              <v-card-text class="mainFont--text">
                <div v-if="pageLoading" class="text-center">
                  <looping-rhombuses-spinner
                    :animation-duration="2500"
                    :rhombus-size="15"
                    color="#6200ea"
                    class="mx-auto my-10"
                  />
                </div>
                <div v-else>
                  <div v-if="addressesList && addressesList.length">
                    <v-card
                      class="card-addres mb-4"
                      v-for="(item, index) in computedlistaddress"
                      :key="index"
                    >
                      <div class="line-items-profile mt-4">
                        <v-col xl="6" md="6" lg="6" sm="6" xs="6">
                          <div class="title_details-profile">
                            <h6
                              class="fs-medium font-weight-bold shoppurple--text ml-1"
                            >
                              عنوان آدرس:
                            </h6>
                            <h6
                              class="px-1 fs-medium font-weight-bold secondary--text"
                            >
                              {{ item.addressTitle }}
                            </h6>
                          </div>
                        </v-col>
                        <v-col xl="6" md="6" lg="6" sm="6" xs="6">
                          <div class="title_details-profile">
                            <h6
                              class="fs-medium font-weight-bold shoppurple--text ml-1"
                            >
                              نام گیرنده:
                            </h6>
                            <h6
                              class="px-1 fs-medium font-weight-bold secondary--text"
                            >
                              <strong>{{ item.name }}</strong>
                            </h6>
                          </div>
                        </v-col>
                        <v-col xl="6" md="6" lg="6" sm="6" xs="6">
                          <div class="title_details-profile">
                            <h6
                              class="fs-medium font-weight-bold shoppurple--text ml-1"
                            >
                              موبایل گیرنده:
                            </h6>
                            <h6
                              class="px-1 fs-medium font-weight-bold secondary--text"
                            >
                              <strong>{{ item.mobile }}</strong>
                            </h6>
                          </div>
                        </v-col>

                        <v-col xl="6" md="6" lg="6" sm="6" xs="6">
                          <div class="title_details-profile">
                            <h6
                              class="fs-medium font-weight-bold shoppurple--text ml-1"
                            >
                              آدرس:
                            </h6>
                            <div class="addrss__details d-flex">
                              <h6
                                class="px-1 fs-medium font-weight-bold secondary--text"
                              >
                                {{ item.stateName }}, {{ item.cityName }},
                                {{
                                  item.cityName === "تهران"
                                    ? `منطقه ${item.district}, `
                                    : ""
                                }}
                                {{ item.address }}
                              </h6>
                            </div>
                          </div>
                        </v-col>
                        <v-col xl="6" md="6" lg="6" sm="6" xs="6">
                          <div class="title_details-profile">
                            <h6
                              class="fs-medium font-weight-bold shoppurple--text ml-1"
                            >
                              کد پستی :
                            </h6>
                            <h6
                              class="px-1 fs-medium font-weight-bold secondary--text"
                            >
                              {{ item.postalCode }}
                            </h6>
                          </div>
                        </v-col>
                      </div>
                      <v-row class="justify-content-end align-end text-left">
                        <v-col cols="12" xl="2" lg="2" md="3" sm="6" xs="12">
                          <v-btn
                            @click="editAddress(item)"
                            :loading="loading"
                            class="primary"
                            width="100%"
                            height="36"
                          >
                            ویرایش
                          </v-btn>
                        </v-col>
                        <v-col cols="12" xl="2" lg="2" md="3" sm="6" xs="12">
                          <v-btn
                            @click="askDeleteAddress(item)"
                            :loading="loading"
                            class="red-mainBtn white--text"
                            width="100%"
                            height="36"
                          >
                            حذف
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </div>

                  <div v-if="!addressesList.length">
                    <h6 class="mainFont--text fs-medium font-weight-bold">
                      هنوز آدرسی ثبت نکرده‌اید.
                    </h6>
                  </div>
                </div>
                <v-col
                  xl="12"
                  lg="12"
                  md="12"
                  sm="12"
                  xs="12"
                  v-if="addressesList.length"
                >
                  <div class="page_number_order">
                    <v-pagination
                      v-model="currentPage"
                      prev-icon="$ArrowLeft"
                      next-icon="$ArrowRight"
                      :length="Math.ceil(addressesList.length / perPage)"
                    >
                    </v-pagination>
                  </div>
                </v-col>
                <v-row class="d-flex justify-content-end">
                  <v-btn
                    class="pointer mt-4 purple2-mainBtn"
                    @click="
                      dialogaddnew = true;
                      newAddress = {};
                    "
                  >
                    افزودن آدرس
                  </v-btn>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <!-- favourites list -->
          <v-tab-item>
            <v-card class="common-card">
              <v-card-title class="white black--text p-0">
                <div class="d-flex align-center">
                  <v-icon class="me-3 black--text fs-small">$BlackHeart</v-icon>
                  <span class="fs-medium2">لیست علاقه‌مندی‌ها</span>
                </div>
              </v-card-title>
              <v-card-text>
                <span v-show="false">{{ reactivity }}</span>

                <div v-if="pageLoading" class="text-center">
                  <looping-rhombuses-spinner
                    :animation-duration="2500"
                    :rhombus-size="15"
                    color="#6200ea"
                    class="mx-auto my-10"
                  />
                </div>
                <div v-else>
                  <div v-if="favourites.length" class="card_profile_fav">
                    <v-col
                      v-for="(item, index) in listfavourites"
                      :key="index"
                      xl="3"
                      lg="3"
                      md="3"
                      sm="6"
                      xs="12"
                      class="text-center"
                    >
                      <StoreItem :item="item" />
                    </v-col>
                    <v-col
                      xl="12"
                      lg="12"
                      md="12"
                      sm="12"
                      xs="12"
                      v-if="favourites.length"
                    >
                      <div class="page_number_order">
                        <v-pagination
                          v-model="currentPagefav"
                          prev-icon="$ArrowLeft"
                          next-icon="$ArrowRight"
                          :length="Math.ceil(favourites.length / perPagefav)"
                        >
                        </v-pagination>
                      </div>
                    </v-col>
                  </div>
                  <v-row v-else class="justify-center flex-column mb-0 pb-0">
                    <v-col xl="12" lg="12" md="12" sm="12" xs="12" cols="12">
                      <h6 class="text-center mainFont--text mx-auto">
                        لیست محصولات مورد علاقه شما خالی است!
                      </h6>
                    </v-col>
                    <v-col xl="12" lg="12" md="12" sm="12" xs="12" cols="12">
                      <h6 class="text-center pe-2 ps-2 mainFont--text">
                        شما می‌توانید هنگام مشاهده محصول گزینه (افزودن به
                        علاقه‌مندی‌ها) را انتخاب نموده و محصول مورد نظر را در
                        این قسمت مشاهده کنید.
                      </h6>
                    </v-col>
                    <v-col
                      xl="12"
                      lg="12"
                      md="12"
                      sm="12"
                      xs="12"
                      cols="12"
                      align="center"
                    >
                      <div class="img-favourite-profile">
                        <img src="/favourite.jpg" />
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <!-- Message List-->
          <v-tab-item>
            <v-card class="common-card">
              <v-card-title class="white black--text">
                <v-icon class="me-3 black--text">mdi-message-outline</v-icon>
                پیام‌ها و تخفیفات
              </v-card-title>

              <v-card-text>
                <div class="item-messagesDiscounts">
                  <h6>
                    از این بخش میتوانید پیام‌های سیستمی را دریافت کنید و از
                    تخفیف‌های متنوع کتاب‌ باز مطلع و بهره‌مند شوید.
                  </h6>
                </div>
                <div class="details-messagesDiscounts">
                  <h6>
                    در حال حاضر پیامی برای شما ارسال نشده است. مرتبا به این صفحه
                    سر بزنید تا اتفاقی را از دست ندهید!
                  </h6>
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </div>

    <!--Purchase Dialog-->
    <v-dialog v-model="purchasedDialog" width="600">
      <v-card>
        <v-card-title class="white d-flex">
          <v-col xl="6" lg="6" md="6" sm="6" xs="6" cols="6">
            <span class="fs-medium font-weight-bold shopPrimary--text">
              اطلاعات خرید
            </span>
          </v-col>
          <v-col xl="6" lg="6" md="6" sm="6" xs="6" cols="6" align="end">
            <v-icon class="shopPrimary--text" @click="purchasedDialog = false"
              >mdi-close</v-icon
            >
          </v-col>
        </v-card-title>
        <hr />
        <v-card-text>
          <v-card
            class="d-flex mb-3 common-card flex-column"
            style="background-color: #eee !important"
          >
            <div class="text-center mt-0 mt-sm-4 d-flex">
              <div>قیمت کالاها:</div>
              <div class="ms-1">
                {{
                  selectedRow.totalCost
                    ? selectedRow.totalCost.toLocaleString()
                    : 0
                }}
                تومان
              </div>
            </div>
            <div class="text-center mt-4 d-flex">
              <div>هزینه ارسال:</div>
              <div class="ms-1">
                <div class="d-flex">
                  {{
                    selectedRow.shippingCost
                      ? selectedRow.shippingCost.toLocaleString()
                      : "رایگان"
                  }}
                  <div v-if="selectedRow.shippingCost">تومان</div>
                </div>
              </div>
            </div>

            <hr />
            <div class="mt-0 mt-sm-4 d-flex text-center shopPrimary--text">
              <div>مبلغ نهایی :</div>
              <div class="ms-1">
                <div class="shopPrimary--text">
                  {{
                    selectedRow.totalPayablePrice
                      ? selectedRow.totalPayablePrice.toLocaleString()
                      : 0
                  }}
                  تومان
                </div>
              </div>
            </div>
          </v-card>
          <v-card
            v-for="(item, index) in selectedPurchase"
            :key="index"
            class="d-flex mx-10 mt-2 mb-3 common-card"
            style="background-color: #eee !important"
          >
            <v-row>
              <v-col cols="12" md="4" class="d-flex justify-center">
                <img
                  :src="item.pictureUrl ? item.pictureUrl : '/no-image.png'"
                  class="stuff-image"
                />
              </v-col>
              <v-col cols="12" md="5" class="text-center">
                <div class="mt-0 mt-sm-4 ms-0 ms-sm-6">
                  <span>{{ item.name }}</span>
                </div>
              </v-col>
              <v-col cols="12" md="3" class="text-center">
                <div class="mt-0 mt-sm-4">
                  <div>
                    <p>
                      {{ item.price ? item.price.toLocaleString() : 0 }}
                      تومان
                    </p>
                  </div>
                </div>
                <div>
                  <span>تعداد: </span>
                  {{ item.amount }}
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>
        <div class="py-3 pe-4">
          <div class="text-left">
            <v-btn
              class="white--text shopPrimary"
              @click="purchasedDialog = false"
              >بستن
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <!--Edit Profile Dialog-->
    <v-dialog v-model="editProfileDialog" width="600">
      <v-card class="card_modals">
        <v-card-title class="white shopPrimary--text d-flex">
          <v-col xl="10" lg="10" md="10" sm="10" xs="10" cols="10">
            <span class="fs-small font-weight-bold">
              ویرایش اطلاعات پروفایل
            </span>
          </v-col>
          <v-col xl="2" lg="2" md="2" sm="2" xs="2" cols="2" align="end">
            <v-icon class="shopPrimary--text" @click="editProfileDialog = false"
              >mdi-close</v-icon
            >
          </v-col>
        </v-card-title>
        <hr class="my-0" />
        <v-card-text>
          <div class="line-response_item">
            <v-col md="12" xl="12" lg="12" sm="12" xs="12">
              <div class="img-loading" v-if="uploading">
                <v-progress-circular
                  indeterminate
                  color="primary"
                  :size="40"
                ></v-progress-circular>
                <h6 class="mt-4 grey--text text--darken-4">
                  در حال بارگذاری...
                </h6>
              </div>
              <div
                class="img-box pointer"
                @click="$refs.theFile.$refs.input.click()"
                v-else
              >
                <img
                  class="img"
                  :src="
                    editProfile.avatarId ? editProfile.avatarUrl : 'Avatar.png'
                  "
                />
                <!-- <v-icon x-large class="img-icon white--text">mdi-camera</v-icon> -->
              </div>
            </v-col>
            <v-col md="12" xl="12" lg="12" sm="12" xs="12">
              <div>
                <v-btn
                  class="primary-borderedBtn pa-5 mt-8"
                  style="width: 100%"
                  @click="$refs.theFile.$refs.input.click()"
                >
                  <v-icon class="me-2">mdi-camera-outline</v-icon> بارگذاری
                  تصویر پروفایل</v-btn
                >
                <v-file-input
                  v-show="false"
                  @change="uploadImage(theFile)"
                  v-model="theFile"
                  ref="theFile"
                  accept="image/png, image/jpeg, image/bmp"
                ></v-file-input>
              </div>
            </v-col>
          </div>

          <v-col md="12" xl="12" lg="12" sm="12" xs="12">
            <v-text-field
              outlined
              dense
              hide-details
              label="نام و نام خانوادگی"
              v-model="editProfile.name"
            >
            </v-text-field>
          </v-col>

          <v-col md="12" xl="12" lg="12" sm="12" xs="12">
            <v-text-field
              outlined
              dense
              hide-details
              type="number"
              label="شماره موبایل "
              v-model="editProfile.mobile"
            >
            </v-text-field>
            <span
              class="red--text"
              v-if="
                !editProfile.mobile ||
                editProfile.mobile.length < 11 ||
                editProfile.mobile.length > 11
              "
              >شماره وارد شده صحیح نمی‌باشد.</span
            >
          </v-col>

          <v-col md="12" xl="12" lg="12" sm="12" xs="12">
            <v-text-field
              label="ایمیل"
              outlined
              dense
              hide-details
              v-model="editProfile.email"
            ></v-text-field>
            <span
              class="red--text"
              v-if="!editProfile.email || !validateEmail(editProfile.email)"
              >ایمیل وارد شده صحیح نمی‌باشد.</span
            >
          </v-col>

          <div class="line-response_item">
            <v-col
              md="4"
              xl="6"
              lg="6"
              sm="4"
              xs="12"
              cols="12"
              class="p-0 m-0"
            ></v-col>
            <v-col
              md="4"
              xl="3"
              lg="3"
              sm="4"
              xs="6"
              cols="12"
              class="py-0 my-0"
            >
              <v-btn
                class="shopPrimary white--text mb-2"
                width="100%"
                height="36"
                :disabled="
                  !editProfile.name ||
                  !editProfile.email ||
                  !validateEmail(editProfile.email) ||
                  !editProfile.mobile ||
                  editProfile.mobile.length < 11 ||
                  editProfile.mobile.length > 11
                "
                @click="submitEditedProfile()"
                >ثبت</v-btn
              >
            </v-col>
            <v-col
              md="4"
              xl="3"
              lg="3"
              sm="4"
              xs="6"
              cols="12"
              class="py-0 my-0"
            >
              <v-btn
                class="purple-borderedBtn"
                width="100%"
                height="36"
                @click="editProfileDialog = false"
                >بستن</v-btn
              >
            </v-col>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- dialog Add Address -->
    <v-dialog v-model="dialogaddnew" width="600">
      <v-card class="card_modals">
        <v-card-title
          class="white shopPrimary--text d-flex justify-content-between"
        >
          <span class="fs-medium font-weight-bold"> افزودن آدرس </span>
          <span>
            <v-icon class="shopPrimary--text" @click="dialogaddnew = false"
              >mdi-close</v-icon
            >
          </span>
        </v-card-title>
        <hr />
        <v-card-text>
          <div class="line-response_item">
            <v-col cols="12">
              <v-text-field
                outlined
                dense
                hide-details
                placeholder=" عنوان آدرس"
                v-model="newAddress.addressTitle"
              >
              </v-text-field>
            </v-col>
            <v-col xl="6" lg="6" md="6" sm="12" xs="12">
              <v-text-field
                outlined
                dense
                hide-details
                placeholder="نام گیرنده "
                v-model="newAddress.name"
              >
              </v-text-field>
            </v-col>
            <v-col xl="6" lg="6" md="6" sm="12" xs="12">
              <v-text-field
                outlined
                dense
                hide-details
                placeholder="موبایل گیرنده "
                v-model="newAddress.mobile"
                type="number"
              >
              </v-text-field>
              <span
                class="red--text text-right mb-3 pt-0 mt-0"
                v-if="
                  newAddress.mobile && !validateMobileNumber(newAddress.mobile)
                "
                >شماره موبایل وارد شده صحیح نمی‌باشد.</span
              >
            </v-col>
          </div>
          <div class="line-response_item">
            <v-col xl="6" lg="6" md="6" sm="12" xs="12">
              <v-select
                dense
                outlined
                hide-details
                placeholder="استان"
                :items="states"
                v-model="newAddress.stateId"
                item-value="id"
                item-text="name"
                @change="updateCity('newAddress')"
              >
                <template v-slot:append>
                  <v-icon>$ArrowDown</v-icon>
                </template>
              </v-select>
            </v-col>
            <v-col xl="6" lg="6" md="6" sm="12" xs="12">
              <v-select
                :items="cities"
                v-model="newAddress.city"
                :loading="gettingCitiesLoading"
                dense
                outlined
                hide-details
                placeholder="شهر"
                item-value="id"
                item-text="name"
                return-object
                @change="cityLog(editingAddress.city)"
              >
                <template v-slot:append>
                  <v-icon>$ArrowDown</v-icon>
                </template>
              </v-select>
            </v-col>
          </div>

          <span v-show="false">{{ reactivity }}</span>
          <div
            class="line-response_item align-center"
            v-if="newAddress.city && newAddress.city.name === 'تهران'"
          >
            <v-col xl="6" lg="6" md="6" sm="12" xs="12">
              <v-select
                dense
                outlined
                hide-details
                placeholder="منطقه"
                :items="districts"
                v-model="newAddress.district"
                item-value="id"
                item-text="name"
              >
                <template v-slot:append>
                  <v-icon>$ArrowDown</v-icon>
                </template>
              </v-select>
            </v-col>
            <v-col xl="6" lg="6" md="6" sm="12" xs="12">
              <v-text-field
                outlined
                dense
                hide-details
                placeholder=" کد پستی"
                v-model="newAddress.postalCode"
                type="number"
              >
              </v-text-field>
            </v-col>
          </div>
          <div class="line-response_item align-center">
            <v-col
              xl="12"
              lg="12"
              md="12"
              sm="12"
              xs="12"
              v-if="newAddress.city && newAddress.city.name !== 'تهران'"
            >
              <v-text-field
                outlined
                dense
                hide-details
                placeholder=" کد پستی"
                v-model="newAddress.postalCode"
                type="number"
              >
              </v-text-field>
            </v-col>
          </div>
          <div class="line-response_item align-center">
            <v-col xl="12" lg="12" md="12" sm="12" xs="12">
              <v-textarea
                outlined
                dense
                v-model="newAddress.address"
                :rules="daddressesRules"
                :loading="loading"
                placeholder="آدرس"
              >
              </v-textarea>
            </v-col>
          </div>

          <div class="line-response_item">
            <v-col md="8" xl="8" lg="8" sm="6" xs="6" class="p-0 m-0"></v-col>
            <v-col
              md="4"
              xl="4"
              lg="4"
              sm="6"
              xs="6"
              class="py-0 my-0 d-flex justify-content-end"
            >
              <v-btn
                class="shopPrimary white--text ml-2"
                @click="addAddress()"
                :disabled="
                  !newAddress.address ||
                  !newAddress.addressTitle ||
                  !newAddress.name ||
                  !newAddress.stateId ||
                  !newAddress.postalCode ||
                  !newAddress.city ||
                  !newAddress.mobile ||
                  !validateMobileNumber(newAddress.mobile)
                "
                >ثبت</v-btn
              >

              <v-btn class="purple-borderedBtn" @click="dialogaddnew = false"
                >بستن</v-btn
              >
            </v-col>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- dialog Edit Address -->
    <v-dialog v-model="dialogEdit" width="600">
      <v-card class="card_modals">
        <v-card-title
          class="white shopPrimary--text d-flex justify-content-between"
        >
          <span class="fs-medium font-weight-bold"> ویرایش آدرس </span>
          <span>
            <v-icon class="shopPrimary--text" @click="dialogEdit = false"
              >mdi-close</v-icon
            >
          </span>
        </v-card-title>
        <hr />
        <v-card-text>
          <div class="line-response_item">
            <v-col cols="12">
              <v-text-field
                outlined
                dense
                hide-details
                placeholder=" عنوان آدرس"
                v-model="editingAddress.addressTitle"
              >
              </v-text-field>
            </v-col>
            <v-col xl="6" lg="6" md="6" sm="12" xs="12">
              <v-text-field
                outlined
                dense
                hide-details
                label="نام گیرنده "
                v-model="editingAddress.name"
              >
              </v-text-field>
            </v-col>
            <v-col xl="6" lg="6" md="6" sm="12" xs="12">
              <v-text-field
                outlined
                dense
                hide-details
                label="موبایل گیرنده"
                v-model="editingAddress.mobile"
              >
              </v-text-field>
              <span
                class="red--text text-right mb-3 pt-0 mt-0"
                v-if="
                  editingAddress.mobile &&
                  !validateMobileNumber(editingAddress.mobile)
                "
                >شماره موبایل وارد شده صحیح نمی‌باشد.</span
              >
            </v-col>
          </div>
          <div class="line-response_item">
            <v-col xl="6" lg="6" md="6" sm="12" xs="12">
              <v-select
                dense
                outlined
                hide-details
                placeholder="استان"
                :items="states"
                v-model="editingAddress.stateId"
                item-value="id"
                item-text="name"
                @change="updateCity('editingAddress')"
              >
                <template v-slot:append>
                  <v-icon>$ArrowDown</v-icon>
                </template>
              </v-select>
            </v-col>
            <v-col xl="6" lg="6" md="6" sm="12" xs="12">
              <v-select
                dense
                outlined
                hide-details
                placeholder="شهر"
                :items="cities"
                v-model="editingAddress.city"
                item-value="id"
                item-text="name"
                return-object
                @change="cityLog(editingAddress.city)"
              >
                <template v-slot:append>
                  <v-icon>$ArrowDown</v-icon>
                </template>
              </v-select>
            </v-col>
          </div>

          <span v-show="false">{{ reactivity }}</span>
          <div
            class="line-response_item"
            v-if="editingAddress.city && editingAddress.city.name == 'تهران'"
          >
            <v-col xl="6" lg="6" md="6" sm="12" xs="12">
              <v-select
                dense
                outlined
                hide-details
                placeholder="منطقه"
                :items="districts"
                v-model="editingAddress.district"
                item-value="id"
                item-text="name"
              >
                <template v-slot:append>
                  <v-icon>$ArrowDown</v-icon>
                </template>
              </v-select>
            </v-col>
            <v-col xl="6" lg="6" md="6" sm="12" xs="12">
              <v-text-field
                outlined
                dense
                hide-details
                label=" کد پستی"
                v-model="editingAddress.postalCode"
                :loading="loading"
              >
              </v-text-field>
            </v-col>
          </div>
          <div class="line-response_item">
            <v-col
              xl="12"
              lg="12"
              md="12"
              sm="12"
              xs="12"
              v-if="editingAddress.city && editingAddress.city.name !== 'تهران'"
            >
              <v-text-field
                outlined
                dense
                hide-details
                label=" کد پستی"
                v-model="editingAddress.postalCode"
                :loading="loading"
              >
              </v-text-field>
            </v-col>
          </div>
          <div class="line-response_item">
            <v-col xl="12" lg="12" md="12" sm="12" xs="12">
              <v-textarea
                outlined
                dense
                v-model="editingAddress.address"
                :rules="daddressesRules"
                :loading="loading"
                label="آدرس"
              >
              </v-textarea>
            </v-col>
          </div>

          <div class="line-response_item">
            <v-col md="8" xl="8" lg="8" sm="6" xs="6" class="p-0 m-0"></v-col>
            <v-col
              md="4"
              xl="4"
              lg="4"
              sm="6"
              xs="6"
              class="py-0 my-0 d-flex justify-content-end"
            >
              <v-btn
                class="shopPrimary white--text ml-2"
                @click="editUseraddress()"
                :disabled="
                  !editingAddress.address ||
                  !editingAddress.addressTitle ||
                  !editingAddress.name ||
                  !editingAddress.stateId ||
                  !editingAddress.postalCode ||
                  !editingAddress.city ||
                  !editingAddress.mobile ||
                  !validateMobileNumber(editingAddress.mobile)
                "
              >
                ویرایش آدرس در حساب کاربری
              </v-btn>

              <v-btn class="purple-borderedBtn" @click="dialogEdit = false"
                >بستن</v-btn
              >
            </v-col>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- delete address dialog -->
    <v-dialog v-model="askDeleteAddressDialog" width="600">
      <v-card class="card_modals">
        <v-card-title class="white shopPrimary--text d-flex">
          <v-col xl="10" lg="10" md="10" sm="10" xs="10" cols="10">
            <span class="fs-medium font-weight-bold"> حذف آدرس </span>
          </v-col>
          <v-col xl="2" lg="2" md="2" sm="2" xs="2" cols="2" align="end">
            <v-icon
              class="shopPrimary--text"
              @click="askDeleteAddressDialog = false"
              >mdi-close</v-icon
            >
          </v-col>
        </v-card-title>
        <hr class="my-0" />
        <v-card-text>
          <v-col xl="12" lg="12" md="12" sm="12" xs="12" cols="12">
            <span class="fs-medium black--text">
              آیا از حذف این آدرس اطمینان دارید؟
            </span>
          </v-col>
          <div class="d-flex justify-end">
            <v-col xl="3" lg="3" md="3" sm="6" xs="12" cols="12">
              <v-btn
                class="red-mainBtn white--text"
                height="35"
                width="100%"
                @click="deleteAddress()"
                :loading="loading"
              >
                بله</v-btn
              >
            </v-col>
            <v-col xl="3" lg="3" md="3" sm="6" xs="12" cols="12">
              <v-btn
                class="primary white--text"
                height="35"
                width="100%"
                @click="askDeleteAddressDialog = false"
              >
                خیر</v-btn
              >
            </v-col>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Axios from "axios";
import { HalfCircleSpinner, LoopingRhombusesSpinner } from "epic-spinners";
import ProductCounter from "./../../components/OnlineShop/ProductCounter";
import { isEmpty } from "ramda";
import StoreItem from "@/views/OnlineShop/StoreAll/Components/StoreItem";
export default {
  components: {
    StoreItem,
    LoopingRhombusesSpinner,
    ProductCounter,
    HalfCircleSpinner,
  },
  data() {
    return {
      selectedAddress: {},
      askDeleteAddressDialog: false,
      options: [],
      addLoading: [],
      creditCurrentPage: 1,
      pageLoading: false,
      disableLeft: false,
      disableRight: false,
      cart: [],
      profile: [],
      selectedSale: {},
      userId: "",
      tabs: null,
      currentPage: 1,
      perPage: 2,
      currentPagefav: 1,
      perPagefav: 4,
      purchasedDialog: false,
      filter: "",
      reactivity: false,

      purchaseFields: [
        { value: "index", text: "ردیف", align: "center", sortable: false },
        { value: "date", text: "تاریخ", align: "center", sortable: false },
        {
          value: "invoiceCode",
          text: "کد پیگیری",
          align: "center",
          sortable: false,
        },
        {
          value: "totalCost",
          text: " مبلغ کل (تومان) ",
          align: "center",
          sortable: false,
        },
        {
          value: "totalPayablePrice",
          text: " مبلغ پرداختی (تومان) ",
          align: "center",
          sortable: false,
        },
        { value: "status", text: "وضعیت", align: "center", sortable: false },
        {
          value: "operation",
          text: "عملیات",
          align: "center",
          sortable: false,
        },
      ],
      expanded: [],
      selectedRow: {},
      singleExpand: false,
      districts: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22,
      ],
      wares: [],
      editProfileDialog: false,

      selectedPurchase: [],
      pageLoading: false,
      stateLoading: false,

      cityLoading: false,
      creditTransactions: [],
      creditHeaders: [
        // { value: "index", text: "ردیف", sortable: false },
        { value: "date", text: "تاریخ", sortable: false },
        // { value: "time", text: "ساعت", sortable: false },
        { value: "shopInvoiceCode", text: "کد فاکتور", sortable: false },
        { value: "purchaseMethod", text: "نوع خرید ", sortable: false },
        { value: "productsValue", text: "مبلغ نهایی (تومان)", sortable: false },
        {
          value: "invoiceTotalCost",
          text: "مبلغ پرداختی (تومان)",
          sortable: false,
        },
        { value: "amount", text: "مبلغ اعتبار (تومان) ", sortable: false },
        { value: "type", text: "نوع اعتبار ", sortable: false },
      ],
      rules: [
        (value) => {
          return (
            !value ||
            !value.length ||
            value[0].size < 5000000 ||
            "اندازه عکس شما باید کمتر از 5 مگابایت باشد"
          );
        },
      ],
      lastNameRules: [
        (value) => {
          if (value) return true;

          return "لطفا نام و نام خانوادگی خود را وارد کنید";
        },
      ],
      MobileRules: [
        (value) => {
          if (value) return true;

          return "شماره موبایل الزامی است.";
        },
        (value) => {
          if (/^09\d{9}$/.test(value)) return true;

          return "شماره موبایل معتبر نیست";
        },
      ],
      emailRules: [
        (value) => {
          if (value) return true;

          return "لطفا پست الکترونیک خود را وارد کنید ";
        },
        (value) => {
          if (/.+@.+\..+/.test(value)) return true;

          return " پست الکترونیک وارد شده معتبر نیست";
        },
      ],

      editProfile: {
        name: "",
        mobile: "",
        email: "",
        avatarId: "",
        avatarUrl: "",
      },
      userData: {
        name: "",
        mobile: "",
        email: "",
        avatarId: "",
        avatarUrl: "",
      },
      daddressesRules: [
        (value) => {
          if (value) return true;

          return "لطفا آدرس  خود را وارد کنید";
        },
      ],
      codeRules: [
        (value) => {
          if (value) return true;

          return "لطفا  کد پستی خود را وارد کنید";
        },
      ],
      areaRules: [
        (value) => {
          if (value) return true;

          return "لطفا نام منطقه خود را وارد کنید";
        },
      ],
      stateRules: [
        (value) => {
          if (value) return true;

          return "لطفا استان خود را انتخاب کنید";
        },
      ],
      cityRules: [
        (value) => {
          if (value) return true;

          return "لطفا نام شهر خود را وارد کنید";
        },
      ],

      addressTitle: "",
      name: "",
      stateName: "",
      cityName: "",
      address: "",
      district: "",
      postalCode: "",
      editingAddress: {
        addressTitle: "",
        name: "",
        stateId: "",
        city: "",
        district: "",
        postalCode: "",
        address: "",
        mobile: "",
      },
      newAddress: {
        addressTitle: "",
        name: "",
        stateId: "",
        city: "",
        district: "",
        postalCode: "",
        address: "",
        mobile: "",
      },
      theFile: {},
      uploading: false,
      editLoading: false,
      favourites: [],
      addressesList: [],
      shopInvoices: [],
      shopInvoicesLength: [],
      states: [],
      cities: [],
      submitLoading: false,
      editAddresses: {},
      gettingCitiesLoading: false,
      loading: false,
      dialogEdit: false,
      dialogaddnew: false,
      disableButton: true,
      currentPagePurch: 1,
      perPagePurch: 2,
    };
  },
  watch: {
    currentPage(value) {},
    userData: {
      handler: function (after, before) {
        let keyuserData = [];
        for (const [key, value] of Object.entries(before)) {
          if (isEmpty(value)) keyuserData.push(key);
        }
        this.disableButton = false;
      },
      deep: true,
    },
  },
  methods: {
    validateMobileNumber(mobile) {
      const pattern = /^(?:\+98|0)?9\d{9}$/; // Regex pattern for Iranian  mobile
      return pattern.test(mobile);
    },
    askDeleteAddress(item) {
      this.selectedAddress = item;
      this.askDeleteAddressDialog = true;
    },
    deleteAddress() {
      this.pageLoading = true;
      Axios.patch(
        this.baseUrl +
          "/onlineShop/user/deleteAddress/" +
          this.selectedAddress.id,
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.pageLoading = false;
            this.askDeleteAddressDialog = false;
            this.toast(res.data.message, "success");
            this.getAddresses();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.pageLoading = false;

            this.askDeleteAddressDialog = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.pageLoading = false;
          this.askDeleteAddressDialog = false;
        });
    },
    cityLog(i) {
      this.reactivity = !this.reactivity;
      this.editingAddress.city = { name: i.name, id: i.id };
    },
    openEditPersonalInfo() {
      this.editProfile = JSON.parse(JSON.stringify(this.userData));
      this.editProfileDialog = true;
    },
    submitEditedProfile() {
      this.editLoading = true;
      Axios.patch(
        this.baseUrl + "/onlineShop/user/edit",
        {
          name: this.editProfile.name,
          mobile: this.editProfile.mobile,
          email: this.editProfile.email,
          avatarId: this.editProfile.avatarId,
          avatarUrl: this.editProfile.avatarUrl,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            localStorage.setItem("name", this.editProfile.name);
            localStorage.setItem("mobile", this.editProfile.mobile);
            this.editLoading = false;
            this.editProfileDialog = false;
            this.getuserData();
            this.toast(res.data.message, "success");
          }
        })
        .catch((err) => {
          this.editLoading = false;
          this.editProfileDialog = false;
          this.toast(err.response.data, "error");
        });
    },
    test() {
      console.log(document.getElementById("uploadFile"));
      document.getElementById("uploadFile").click();
    },
    getuserData() {
      this.pageLoading = true;
      Axios.get(this.baseUrl + "/onlineShop/user/getData", {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("shopToken"),
        },
      })
        .then((res) => {
          if (res.status == 200) {
            this.pageLoading = false;
            this.userData = res.data;
            this.favourites = res.data.favourites;
            this.shopInvoices = res.data.shopInvoices;
            this.shopInvoicesLength = res.data.shopInvoices.length;
          }
        })
        .catch((err) => {
          this.pageLoading = false;
          this.toast("خطا: " + err.response.data, "error");
          console.log(err);
        });
    },
    uploadImage() {
      let sizeMB = this.theFile.size / 1024 / 1024;
      if (sizeMB > 5) {
        this.toast(
          "حجم فایل " + this.theFile[0].name + " نباید از 5 مگابایت بیشتر باشد",
          "error"
        );
        return;
      } else {
        //CHECK theFile SIZE
        this.uploading = false;
        var formData = new FormData();
        console.log(this.theFile);
        formData.append(this.theFile.name, this.theFile);
        Axios.post(this.baseUrl + "/onlineShop/user/uploadAvatar", formData, {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        })
          .then((res) => {
            if (res.status == 200) {
              this.editProfile.avatarId = res.data.id;
              this.editProfile.avatarUrl = res.data.url;
              this.uploading = false;
              this.toast(res.data.message, "success");
            }
          })
          .catch((err) => {
            this.uploading = false;
            this.toast(err.response.data, "error");
          });
      }
    },
    goToDetails(item) {
      console.log(item);
      this.$router.push({
        path: "/orderDetails/" + item.id,
      });
    },
    editAddress(item) {
      this.editingAddress = JSON.parse(JSON.stringify(item));
      if (this.editingAddress.stateId) {
        this.getCities("editingAddress");
      }
      if (this.editingAddress && this.editingAddress.cityId) {
        this.editingAddress.city = {
          name: this.editingAddress.cityName,
          id: this.editingAddress.cityId,
        };
      }
      this.dialogEdit = true;
    },
    getAddresses() {
      Axios.get(this.baseUrl + "/onlineShop/user/address/list", {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("shopToken"),
        },
      })
        .then((res) => {
          if (res.status == 200) {
            this.addressesList = res.data;
            this.pageLoading = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          console.log(err);
          this.pageLoading = false;
        });
    },
    editUseraddress() {
      Axios.patch(
        this.baseUrl + "/onlineShop/user/editAddress/" + this.editingAddress.id,
        {
          mobile: this.editingAddress.mobile,
          address: this.editingAddress.address,
          addressTitle: this.editingAddress.addressTitle,
          postalCode: this.editingAddress.postalCode,
          cityId: this.editingAddress.city ? this.editingAddress.city.id : "",
          stateId: this.editingAddress.stateId,
          cityName: this.editingAddress.cityName,
          district:
            this.editingAddress.city && this.editingAddress.city.name == "تهران"
              ? Number(this.editingAddress.district)
              : undefined,
          name: this.editingAddress.name,
          id: this.editingAddress.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.getAddresses();
            this.dialogEdit = false;
            this.toast(res.data.message, "success");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.dialogEdit = false;
        });
    },
    addAddress() {
      this.submitLoading = true;
      Axios.post(
        this.baseUrl + "/onlineShop/user/addAddress",
        {
          name: this.newAddress.name,
          mobile: this.newAddress.mobile,
          address: this.newAddress.address,
          addressTitle: this.newAddress.addressTitle,
          postalCode: this.newAddress.postalCode,
          cityId: this.newAddress.city ? this.newAddress.city.id : "",
          stateId: this.newAddress.stateId,
          district: this.newAddress.district,
          id: this.newAddress.id,
        },

        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.submitLoading = false;
            this.toast("آدرس با موفقیت اضافه شد", "success");
            this.dialogaddnew = false;
            this.getAddresses();
            this.$refs.reset();
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.dialogaddnew = false;
          this.submitLoading = false;
        });
    },
    getStates() {
      Axios.get(this.baseUrl + "/onlineShop/states/list", {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("shopToken"),
        },
      })
        .then((res) => {
          this.states = res.data;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    updateCity(parent) {
      this[parent].city = {};
      this.getCities(parent);
    },
    getCities(parent) {
      this.gettingCitiesLoading = true;

      Axios.get(
        this.baseUrl +
          "/onlineShop/cities/listforstate/" +
          this[parent].stateId,

        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          this.cities = res.data;
          this.reactivity = !this.reactivity;
          this.gettingCitiesLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.gettingCitiesLoading = false;
        });
    },
    goToProduct(item) {
      this.$router.push("/productDetails/" + item);
    },
    addToCart(item) {
      Axios.post(
        this.baseUrl + "/onlineShop/cart/addItem/" + this.cartId,
        {
          amount: 1,
          warehouseItemId: item,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data.message, "success");
          } else {
            this.toast("خطایی رخ داده است. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
  },
  computed: {
    computedItemsCount() {
      if (this.shopInvoices) {
        return this.shopInvoices.filter((x) => x.sum != 0).length;
      } else {
        return this.shopInvoices.length;
      }
    },
    computedItems() {
      let pageFrom = (this.currentPagePurch - 1) * this.perPagePurch;
      console.log("sdssdsdsds");
      let pageTo = pageFrom + this.perPagePurch;
      let myItems = this.shopInvoices;
      if (this.shopInvoices) {
        myItems = myItems.filter((x) => x.sum != 0);
      }
      return myItems.slice(pageFrom, pageTo);
    },
    computedlistaddress() {
      const startIndex = (this.currentPage - 1) * this.perPage;
      const endIndex = startIndex + this.perPage;
      const myItems = this.addressesList;
      return this.addressesList.slice(startIndex, endIndex);
    },
    listfavourites() {
      const startIndex = (this.currentPagefav - 1) * this.perPagefav;
      const endIndex = startIndex + this.perPagefav;
      const myItems = this.favourites;
      return this.favourites.slice(startIndex, endIndex);
    },
  },
  mounted() {
    this.editAddresses = this.allAdresses;
    this.getStates();
    for (let i = 1; i < 23; i++) {
      this.districts.push(i);
    }
    this.getuserData();
    this.getAddresses();
    if (!localStorage.getItem("shopToken")) {
      this.toast("ابتدا باید لاگین کنید", "error");
      this.$router.push("/main");
    }
  },
};
</script>

<style lang="scss">
.img-favourite-profile {
  width: 250px;
  height: auto;
  img {
    width: 100%;
    height: auto;
    object-fit: contain;
  }
}
* {
  user-select: none;
}
.activestatus {
  color: #00bfa5;
}
.deactivestatus {
  color: #d62728;
}
.pendingClass {
  color: #ff7f0e;
}
.image-list-buy {
  width: 90px;
  height: 130px;
  @media only screen and (max-width: 1366px) {
    width: 120px;
    height: 140px;
  }
  @media only screen and (max-width: 600px) {
    width: 90px;
    height: 130px;
  }
  img {
    width: 100%;
    height: 100%;
    border-radius: 4px;
  }
  h6 {
    font-size: 14px;
    text-align: center;
    margin: 7px 0;
  }
}
.title_details-profile {
  display: flex;
  align-items: center;
  @media only screen and (max-width: 800px) {
    flex-direction: column;
    align-items: flex-start;
  }
}
.line-items-profile {
  display: flex;
  flex-wrap: wrap;
  @media only screen and (max-width: 600px) {
    flex-direction: column;
  }
}

.card_profile_fav {
  display: flex;
  flex-wrap: wrap;
  @media only screen and (max-width: 600px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
.line-response_item {
  display: flex;
  flex-wrap: wrap;
  @media only screen and (max-width: 600px) {
    flex-direction: column;
  }
}
.products {
  &.special-products {
    overflow-x: auto;
    overflow-y: hidden;
    scroll-behavior: smooth;
    &::-webkit-scrollbar {
      display: none;
    }
  }
}

.product-item-profile {
  width: 100%;
  height: 420px;
  background-color: #fff;
  border-radius: 12px !important;
  overflow: hidden;
  @media (max-width: 375px) {
    justify-content: center;
  }

  .product-image_profile {
    position: relative;
    img {
      width: 100%;
      height: 280px;
      border-radius: 12px 12px 0 0;
      aspect-ratio: 1 / 1;
    }
  }
}

.card_modals {
  .v-card__text {
    @media only screen and (max-width: 375px) {
      padding: 10px 5px !important;
    }
  }
}
.stuff-image {
  width: 50%;
  margin: 0 auto;
  border-radius: 10px;
}
.profile {
  overflow: hidden;
  .purchaseTable {
    tr:nth-child(even) {
      background-color: #e9e9e9 !important;
    }
  }
  .v-slide-group__content {
    border-bottom: none !important;
  }
}

.image-box {
  width: 300px;
  transform: translateX(15px);

  @media only screen and (max-width: 280px) {
    width: 250px;
  }
}
.img-user {
  width: 70px;
  height: 70px;
  border: 2px solid rgb(98, 0, 234);
  border-radius: 50%;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
  }
}
.img-box {
  width: 100px;
  height: 100px;
  border: 2px solid rgb(98, 0, 234);
  border-radius: 50%;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
  }
}
.info-user {
  margin-right: 10px;
  p {
    font-size: 15px;
    margin: 0 !important;
  }
}
</style>
